<template>
  <div>
    <!-- 灾害列表  搜索有数据 -->
    <div class="hasData" v-if="isShow">
      <el-table
        empty-text=" "
        v-loading="loading"
        :data="list"
        stripe
        :row-class-name="TableRow"
        :header-cell-style="{ color: '#64C3A4', fontSize: '16px' }"
        :cell-style="{ color: '#666666' }"
      >
        <el-table-column label="灾害名称" width="130px" prop="disasterName" />
        <el-table-column label="灾害类型" width="90px" prop="disasterType">
          <template slot-scope="scope">
            <div>{{ damage_type[scope.row.disasterType] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="申请开始时间" width="145px">
          <template slot-scope="scope">
            {{
              scope.row.reportStartDate || "--" | formatDate("yyyy-MM-dd hh:mm")
            }}
          </template>
        </el-table-column>
        <el-table-column label="申请截止时间" width="145px">
          <template slot-scope="scope">
            {{
              scope.row.reportEndDate || "--" | formatDate("yyyy-MM-dd hh:mm")
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="发布单位"
          width="130px"
          prop="publishSubjectName"
        />
        <el-table-column label="可申报状态" width="120px">
          <!--  申报状态 0-申报未开始 1-可申报 2-申报截止 -->
          <template slot-scope="scope">
            <span
              class="statusColor"
              :class="`active${scope.row.reportStatus}`"
            >
              {{ statusField[scope.row.reportStatus] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="已申报地块数"
          width="130px"
          prop="reportLandNum"
        />
        <el-table-column
          label="审核拒绝地块数"
          width="150px"
          prop="reportLandFailNum"
        >
          <template slot-scope="scope">
            <div :style="{ color: scope.row.reportLandFailNum ? 'red' : '' }">
              {{ scope.row.reportLandFailNum }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <el-button
              @click="checkContent(scope.row)"
              type="text"
              size="small"
              class="button14"
            >
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 搜索后无数据 -->
    <div class="noDataImg" v-else>
      <div class="imgNo">
        <img src="~@/assets/images/damageImg/noData.png" alt="" />
      </div>
      <p style="color: #333">未找到符合条件的数据</p>
    </div>
  </div>
</template>

<script>
import sameIn from "@/mixins/listsdetails.js";
import { damage_report_status, damage_type } from "@/confing/map_tab.js";

export default {
  name: "TableList",
  mixins: [sameIn],
  data() {
    return {
      statusField: damage_report_status,
      damage_type,
    };
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    setAcre(list) {
      let countNum = 0;
      list.forEach((ele) => {
        countNum = countNum + ele.statisticsLandAcre;
      });
      let res = countNum.toString().indexOf(".");
      if (res !== -1) {
        if (countNum.toString().substr(res + 1).length > 2) {
          countNum = countNum.toFixed(2);
        }
      }
      return countNum;
    },
    async checkContent(row) {
      this.$router.push({
        path: "/damage-detail",
        query: {
          id: row.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hasData {
  height: 100%;
}
.statusColor {
  position: relative;
  padding-left: 6px;
  &.active0::after {
    background-color: orange;
  }
  &.active1::after {
    background-color: $--color-primary;
  }
  &::after {
    content: "";
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #d30000;
    left: -3px;
    top: 50%;
    margin-top: -3px;
  }
}
</style>
